import type { ISimplifiedLicenseType } from '$shared/interfaces/api/ISimplifiedLicenseType';
import BaseModel from '$shared/models/BaseModel';

export class SimplifiedLicenseType extends BaseModel<ISimplifiedLicenseType> {
  public get id(): string {
    return this.response?.id || '';
  }

  public get taxonamy(): string {
    return this.response?.taxonomy || '';
  }

  public get name(): string {
    return this.response?.name || '';
  }

  public get aliases(): string[] {
    return this.response?.aliases || [];
  }

  public get abbreviations(): string[] {
    return this.response?.abbreviations || [];
  }

  public get states(): string[] {
    return this.response?.states || [];
  }
}
